import {Container, Paper} from "@mui/material";
import DiscountCodeForm from "../components/DiscountCodeForm.tsx";

const CreateDiscountCodePage = () => {

    return (
        <Container sx={{padding: '12px'}}>
            <Paper
                elevation={4}
                sx={{
                    maxWidth: '900px',
                    margin: 'auto',
                    padding: 2,
                }}
            >
                <DiscountCodeForm/>
            </Paper>
        </Container>
    )
}

export default CreateDiscountCodePage;
